import React from 'react';

//

const lazyDependencies = {
  CreateAccountPage: React.lazy(() => import('../../../pages/create-account')),
  LoginPage: React.lazy(() => import('../../../pages/login')),
};

// Exports
// -------

export default lazyDependencies;
